<template>
    <div id="subtest-list">
        <v-card flat>
            <div v-if="!showForm">
                <v-card outlined class="my-3">
                    <!-- Tryout info -->
                    <v-card-text class="py-5">
                        <div>
                            <v-row>
                                <v-col
                                    md="2"
                                    class="text-right font-weight-bold"
                                >
                                    Kode Tryout:
                                </v-col>
                                <v-col md="10">
                                    {{ $store.state.tryout.code }}
                                </v-col>
                                <v-col
                                    md="2"
                                    class="text-right font-weight-bold py-2"
                                >
                                    Jenjang Tryout:
                                </v-col>
                                <v-col md="10" class="py-2">
                                    {{ $store.state.tryout.level }}
                                </v-col>
                                <v-col
                                    md="2"
                                    class="text-right font-weight-bold"
                                >
                                    Nama Tryout:
                                </v-col>
                                <v-col md="10">
                                    {{ $store.state.tryout.name }}
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>
                </v-card>
            </div>

            <div v-if="!showForm">
                <!-- Tryout Subtest List -->
                <v-card
                    class="my-3 test_cursor"
                    v-for="(subtest, index) in $store.state.tryout.subtests"
                    v-bind:key="subtest.id"
                    :id="'tryout-subtest-' + index"
                    outlined
                    @dblclick="editSubtest(index)"
                >
                    <v-list class="pa-2">
                        <template>
                            <v-list-item two-line>
                                <span
                                    class="roboto-text font-weight-bold mt-3"
                                    style="
                                        top: 0 !important;
                                        position: absolute;
                                    "
                                    >{{ index + 1 }}. &nbsp; &nbsp;
                                </span>
                                <v-list-item-avatar class="mx-2 my-0" tile>
                                    <v-img
                                        :src="subtest.subject_picture"
                                        width="45px"
                                    />
                                </v-list-item-avatar>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title class="font-weight-bold">
                                        {{ subtest.subject_name }}
                                        <v-badge class="mx-2" color="#ECEFF5">
                                            <template v-slot:badge>
                                                <span class="darkFade--text">
                                                    {{ subtest.duration }}m
                                                </span>
                                            </template>
                                        </v-badge>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ subtest.details.length }} Soal
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <!-- Subtest Actions (Not Used) -->
                                <!-- <v-list-item-action>
                  <v-btn plain class="pa-0">
                    <span
                      :class="
                        $vuetify.breakpoint.mdAndUp
                          ? 'font-weight-700'
                          : 'font-weight-600'
                      "
                      :style="
                        $vuetify.breakpoint.smAndDown ? 'font-size: 12px' : ''
                      "
                      >Ubah</span
                    >
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action>
                  <v-btn plain class="pa-0">
                    <span
                      class="red--text"
                      :class="
                        $vuetify.breakpoint.mdAndUp
                          ? 'font-weight-700'
                          : 'font-weight-600'
                      "
                      :style="
                        $vuetify.breakpoint.smAndDown ? 'font-size: 12px' : ''
                      "
                      >Hapus</span
                    >
                  </v-btn>
                </v-list-item-action> -->
                            </v-list-item>
                        </template>
                    </v-list>
                </v-card>
            </div>
            <!-- add new subtest button -->
            <v-btn
                id="tryout-add-subtest-btn"
                block
                class="font-weight-bold dark--text"
                depressed
                color="#FAFAFA"
                style="
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
                    border-radius: 4px;
                "
                @click="createSubtest()"
                v-if="!showForm && $store.state.tryout.status != 'PUBLISHED'"
                >Tambah Subtest Baru</v-btn
            >

            <!-- Subtest Form shown if showForm true -->
            <app-subtestform
                v-if="showForm"
                v-on:completed="showForm = false"
                :subtest="selectedSubtest"
                @back="showForm = false"
            ></app-subtestform>
            <hr />
            <v-card-actions>
                <v-spacer></v-spacer>
                <!-- Back Button -->
                <v-btn
                    id="tryout-back-btn"
                    v-if="!showForm"
                    depressed
                    text
                    @click="$emit('uncompleted')"
                >
                    Kembali
                </v-btn>

                <!-- Next Button -->
                <v-btn
                    id="tryout-next-btn"
                    color="blew"
                    v-if="!showForm"
                    type="button"
                    class="btn btn-success pull-right"
                    @click="$emit('completed')"
                    depressed
                    dark
                >
                    Selanjutnya
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<style>
.subject-picture {
    float: left;
    width: 45px;
    height: 34px;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    overflow: hidden;
    margin: -2px 10px -2px 0;
}
</style>

<script>
import SubtestForm from "@/modules/tryout/components/SubtestForm";

export default {
    name: "subtest-list",

    components: {
        "app-subtestform": SubtestForm,
    },

    data: function () {
        return {
            showForm: false,
            selectedSubtest: null,
        };
    },

    methods: {
        // given detail subtest to tryout_select_subtest for used in app-subtestform
        editSubtest: function (index) {
            this.$store.commit("tryout_select_subtest", index);
            this.showForm = true;
        },
        // trigger tryout_reset_selected_subtest to make emprty in app-subtestform
        createSubtest: function () {
            this.$store.commit("tryout_reset_selected_subtest");
            this.showForm = true;
        },
    },
};
</script>



// WEBPACK FOOTER //
// SubtestList.vue?cc20b72c